import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { PaDatepickerComponent } from 'src/app/shared/ui-kit/pa-datepicker/pa-datepicker.component';
import { PaDatepickerRangeComponent } from 'src/app/shared/ui-kit/pa-datepicker-range/pa-datepicker-range.component';

@Component({
  standalone: true,
  imports: [PaDatepickerComponent, PaDatepickerRangeComponent, ReactiveFormsModule],
  selector: 'app-datepicker-range-view',
  templateUrl: './datepicker-range-view.component.html',
  styleUrls: ['./datepicker-range-view.component.scss'],
})
export class DatepickerRangeViewComponent {

  // Обычный выбор даты
  dateControl = new FormControl();
  
  // Выбор даты и времени
  dateTimeControl = new FormControl();
  
  // Только время
  timeOnlyControl = new FormControl();
  
  // Выбор даты и времени с секундами
  dateTimeWithSecondsControl = new FormControl();
  
  // Обязательное поле
  requiredDateControl = new FormControl(null, [Validators.required]);
  
  // Диапазон дат
  dateRangeControl = new FormControl();
  
  // Обязательный диапазон дат
  requiredDateRangeControl = new FormControl(null, [Validators.required]);

  // Только месяц
  monthControl = new FormControl();

  // Выключенный выбор даты
  disabledDateControl = new FormControl({ value: '10.10.2025', disabled: true });

  // Выключенный диапазон дат
  disabledDateRangeControl = new FormControl({ value: '10.10.2025 - 15.10.2025', disabled: true });
}